var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"transform":"rotate(-180 15 15)","fillRule":"evenodd","clipRule":"evenodd","d":"M18.7782 7.29289C18.3877 6.90237 17.7546 6.90237 17.364 7.29289L10.3199 14.337C10.3108 14.3455 10.3018 14.3542 10.2929 14.3631C10.0775 14.5784 9.98093 14.8676 10.0031 15.1491C10.021 15.3785 10.1176 15.6028 10.293 15.7782C10.3012 15.7864 10.3095 15.7944 10.3179 15.8023L17.364 22.8483C17.7545 23.2389 18.3876 23.2389 18.7782 22.8483C19.1687 22.4578 19.1687 21.8246 18.7782 21.4341L12.4147 15.0707L18.7782 8.70711C19.1688 8.31658 19.1688 7.68342 18.7782 7.29289Z","fill":"black"}));
}

ArrowRight.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
